(function () {
  'use strict';

  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/object-assign/index.js
  var require_object_assign = __commonJS({
    "node_modules/object-assign/index.js"(exports, module) {
      init_react_import();
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;
      function toObject(val) {
        if (val === null || val === void 0) {
          throw new TypeError("Object.assign cannot be called with null or undefined");
        }
        return Object(val);
      }
      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }
          var test1 = new String("abc");
          test1[5] = "de";
          if (Object.getOwnPropertyNames(test1)[0] === "5") {
            return false;
          }
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2["_" + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
          });
          if (order2.join("") !== "0123456789") {
            return false;
          }
          var test3 = {};
          "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
          });
          if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
            return false;
          }
          return true;
        } catch (err) {
          return false;
        }
      }
      module.exports = shouldUseNative() ? Object.assign : function(target, source) {
        var from;
        var to = toObject(target);
        var symbols;
        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);
          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }
          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }
        return to;
      };
    }
  });

  // node_modules/react/cjs/react.production.min.js
  var require_react_production_min = __commonJS({
    "node_modules/react/cjs/react.production.min.js"(exports) {
      init_react_import();
      var l = require_object_assign();
      var n = "function" === typeof Symbol && Symbol.for;
      var p = n ? Symbol.for("react.element") : 60103;
      var q = n ? Symbol.for("react.portal") : 60106;
      var r = n ? Symbol.for("react.fragment") : 60107;
      var t = n ? Symbol.for("react.strict_mode") : 60108;
      var u = n ? Symbol.for("react.profiler") : 60114;
      var v = n ? Symbol.for("react.provider") : 60109;
      var w = n ? Symbol.for("react.context") : 60110;
      var x = n ? Symbol.for("react.forward_ref") : 60112;
      var y = n ? Symbol.for("react.suspense") : 60113;
      var z = n ? Symbol.for("react.memo") : 60115;
      var A = n ? Symbol.for("react.lazy") : 60116;
      var B = "function" === typeof Symbol && Symbol.iterator;
      function C(a) {
        for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)
          b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
      }
      var D = { isMounted: function() {
        return false;
      }, enqueueForceUpdate: function() {
      }, enqueueReplaceState: function() {
      }, enqueueSetState: function() {
      } };
      var E = {};
      function F(a, b, c) {
        this.props = a;
        this.context = b;
        this.refs = E;
        this.updater = c || D;
      }
      F.prototype.isReactComponent = {};
      F.prototype.setState = function(a, b) {
        if ("object" !== typeof a && "function" !== typeof a && null != a)
          throw Error(C(85));
        this.updater.enqueueSetState(this, a, b, "setState");
      };
      F.prototype.forceUpdate = function(a) {
        this.updater.enqueueForceUpdate(this, a, "forceUpdate");
      };
      function G() {
      }
      G.prototype = F.prototype;
      function H(a, b, c) {
        this.props = a;
        this.context = b;
        this.refs = E;
        this.updater = c || D;
      }
      var I = H.prototype = new G();
      I.constructor = H;
      l(I, F.prototype);
      I.isPureReactComponent = true;
      var J = { current: null };
      var K = Object.prototype.hasOwnProperty;
      var L = { key: true, ref: true, __self: true, __source: true };
      function M(a, b, c) {
        var e, d = {}, g = null, k = null;
        if (null != b)
          for (e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)
            K.call(b, e) && !L.hasOwnProperty(e) && (d[e] = b[e]);
        var f = arguments.length - 2;
        if (1 === f)
          d.children = c;
        else if (1 < f) {
          for (var h = Array(f), m = 0; m < f; m++)
            h[m] = arguments[m + 2];
          d.children = h;
        }
        if (a && a.defaultProps)
          for (e in f = a.defaultProps, f)
            void 0 === d[e] && (d[e] = f[e]);
        return { $$typeof: p, type: a, key: g, ref: k, props: d, _owner: J.current };
      }
      function N(a, b) {
        return { $$typeof: p, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
      }
      function O(a) {
        return "object" === typeof a && null !== a && a.$$typeof === p;
      }
      function escape(a) {
        var b = { "=": "=0", ":": "=2" };
        return "$" + ("" + a).replace(/[=:]/g, function(a2) {
          return b[a2];
        });
      }
      var P = /\/+/g;
      var Q = [];
      function R(a, b, c, e) {
        if (Q.length) {
          var d = Q.pop();
          d.result = a;
          d.keyPrefix = b;
          d.func = c;
          d.context = e;
          d.count = 0;
          return d;
        }
        return { result: a, keyPrefix: b, func: c, context: e, count: 0 };
      }
      function S(a) {
        a.result = null;
        a.keyPrefix = null;
        a.func = null;
        a.context = null;
        a.count = 0;
        10 > Q.length && Q.push(a);
      }
      function T(a, b, c, e) {
        var d = typeof a;
        if ("undefined" === d || "boolean" === d)
          a = null;
        var g = false;
        if (null === a)
          g = true;
        else
          switch (d) {
            case "string":
            case "number":
              g = true;
              break;
            case "object":
              switch (a.$$typeof) {
                case p:
                case q:
                  g = true;
              }
          }
        if (g)
          return c(e, a, "" === b ? "." + U(a, 0) : b), 1;
        g = 0;
        b = "" === b ? "." : b + ":";
        if (Array.isArray(a))
          for (var k = 0; k < a.length; k++) {
            d = a[k];
            var f = b + U(d, k);
            g += T(d, f, c, e);
          }
        else if (null === a || "object" !== typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f)
          for (a = f.call(a), k = 0; !(d = a.next()).done; )
            d = d.value, f = b + U(d, k++), g += T(d, f, c, e);
        else if ("object" === d)
          throw c = "" + a, Error(C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
        return g;
      }
      function V(a, b, c) {
        return null == a ? 0 : T(a, "", b, c);
      }
      function U(a, b) {
        return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
      }
      function W(a, b) {
        a.func.call(a.context, b, a.count++);
      }
      function aa(a, b, c) {
        var e = a.result, d = a.keyPrefix;
        a = a.func.call(a.context, b, a.count++);
        Array.isArray(a) ? X(a, e, c, function(a2) {
          return a2;
        }) : null != a && (O(a) && (a = N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + c)), e.push(a));
      }
      function X(a, b, c, e, d) {
        var g = "";
        null != c && (g = ("" + c).replace(P, "$&/") + "/");
        b = R(b, g, e, d);
        V(a, aa, b);
        S(b);
      }
      var Y = { current: null };
      function Z() {
        var a = Y.current;
        if (null === a)
          throw Error(C(321));
        return a;
      }
      var ba = { ReactCurrentDispatcher: Y, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: J, IsSomeRendererActing: { current: false }, assign: l };
      exports.Children = { map: function(a, b, c) {
        if (null == a)
          return a;
        var e = [];
        X(a, e, null, b, c);
        return e;
      }, forEach: function(a, b, c) {
        if (null == a)
          return a;
        b = R(null, null, b, c);
        V(a, W, b);
        S(b);
      }, count: function(a) {
        return V(a, function() {
          return null;
        }, null);
      }, toArray: function(a) {
        var b = [];
        X(a, b, null, function(a2) {
          return a2;
        });
        return b;
      }, only: function(a) {
        if (!O(a))
          throw Error(C(143));
        return a;
      } };
      exports.Component = F;
      exports.Fragment = r;
      exports.Profiler = u;
      exports.PureComponent = H;
      exports.StrictMode = t;
      exports.Suspense = y;
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
      exports.cloneElement = function(a, b, c) {
        if (null === a || void 0 === a)
          throw Error(C(267, a));
        var e = l({}, a.props), d = a.key, g = a.ref, k = a._owner;
        if (null != b) {
          void 0 !== b.ref && (g = b.ref, k = J.current);
          void 0 !== b.key && (d = "" + b.key);
          if (a.type && a.type.defaultProps)
            var f = a.type.defaultProps;
          for (h in b)
            K.call(b, h) && !L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
        }
        var h = arguments.length - 2;
        if (1 === h)
          e.children = c;
        else if (1 < h) {
          f = Array(h);
          for (var m = 0; m < h; m++)
            f[m] = arguments[m + 2];
          e.children = f;
        }
        return {
          $$typeof: p,
          type: a.type,
          key: d,
          ref: g,
          props: e,
          _owner: k
        };
      };
      exports.createContext = function(a, b) {
        void 0 === b && (b = null);
        a = { $$typeof: w, _calculateChangedBits: b, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null };
        a.Provider = { $$typeof: v, _context: a };
        return a.Consumer = a;
      };
      exports.createElement = M;
      exports.createFactory = function(a) {
        var b = M.bind(null, a);
        b.type = a;
        return b;
      };
      exports.createRef = function() {
        return { current: null };
      };
      exports.forwardRef = function(a) {
        return { $$typeof: x, render: a };
      };
      exports.isValidElement = O;
      exports.lazy = function(a) {
        return { $$typeof: A, _ctor: a, _status: -1, _result: null };
      };
      exports.memo = function(a, b) {
        return { $$typeof: z, type: a, compare: void 0 === b ? null : b };
      };
      exports.useCallback = function(a, b) {
        return Z().useCallback(a, b);
      };
      exports.useContext = function(a, b) {
        return Z().useContext(a, b);
      };
      exports.useDebugValue = function() {
      };
      exports.useEffect = function(a, b) {
        return Z().useEffect(a, b);
      };
      exports.useImperativeHandle = function(a, b, c) {
        return Z().useImperativeHandle(a, b, c);
      };
      exports.useLayoutEffect = function(a, b) {
        return Z().useLayoutEffect(a, b);
      };
      exports.useMemo = function(a, b) {
        return Z().useMemo(a, b);
      };
      exports.useReducer = function(a, b, c) {
        return Z().useReducer(a, b, c);
      };
      exports.useRef = function(a) {
        return Z().useRef(a);
      };
      exports.useState = function(a) {
        return Z().useState(a);
      };
      exports.version = "16.14.0";
    }
  });

  // node_modules/react/index.js
  var require_react = __commonJS({
    "node_modules/react/index.js"(exports, module) {
      init_react_import();
      {
        module.exports = require_react_production_min();
      }
    }
  });
  var init_react_import = __esm({
    "src/react-import.js"() {
      __toESM(require_react());
    }
  });

  // src/entries/embla-slider.js
  init_react_import();
  (async () => {
    const generateDots = (dots, $embla, embla) => {
      const template = $embla.querySelector(".embla-dot-template").innerHTML;
      const scrollSnapList = embla.scrollSnapList();
      if (scrollSnapList.length > 1) {
        dots.innerHTML = embla.scrollSnapList().reduce((acc) => acc + template, "");
      }
      return [].slice.call(dots.querySelectorAll(".embla__dot"));
    };
    const selectDot = (dotsArray, embla) => {
      return function() {
        if (dotsArray.length === 0)
          return;
        const previous = embla.previousScrollSnap();
        const selected = embla.selectedScrollSnap();
        dotsArray[previous].classList.remove("is-selected");
        dotsArray[selected].classList.add("is-selected");
      };
    };
    const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
      prevBtn.addEventListener("click", embla.scrollPrev, false);
      nextBtn.addEventListener("click", embla.scrollNext, false);
    };
    const activeSlides = ($container, embla) => {
      return function() {
        const slidesInView = embla.slidesInView();
        $container.querySelectorAll(".embla__slide").forEach((slide, index) => {
          if (slidesInView.includes(index)) {
            slide.classList.add("active");
          } else {
            slide.classList.remove("active");
          }
        });
      };
    };
    const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
      if (!prevBtn || !nextBtn)
        return () => {
        };
      return () => {
        if (embla.canScrollPrev())
          prevBtn.removeAttribute("disabled");
        else
          prevBtn.setAttribute("disabled", "disabled");
        if (embla.canScrollNext())
          nextBtn.removeAttribute("disabled");
        else
          nextBtn.setAttribute("disabled", "disabled");
      };
    };
    const initEmblaSlider = ($embla) => {
      if (Boolean($embla.dataset.initilized) === true)
        return;
      $embla.dataset.initilized = true;
      const $vp = $embla.querySelector(".embla__viewport");
      const $dots = $embla.querySelector(".embla__dots");
      const shouldAutoPlay = $embla.getAttribute("data-autoplay") === "true";
      const plugins = [
        shouldAutoPlay ? EmblaCarouselAutoplay({ stopOnInteraction: false }) : null,
        EmblaCarouselWheelGestures()
      ].filter(Boolean);
      const embla = EmblaCarousel(
        $vp,
        {
          skipSnaps: true,
          containScroll: "trimSnaps",
          ...JSON.parse($embla.getAttribute("data-embla-options")) ?? {}
        },
        plugins
      );
      let setSelectedDot;
      if ($embla.querySelector(".embla-dot-template")) {
        const $dotsArray = generateDots($dots, $embla, embla);
        setSelectedDot = selectDot($dotsArray, embla);
        $dotsArray.forEach(($dot, i) => {
          $dot.addEventListener("click", () => embla.scrollTo(i), false);
        });
      }
      const setActive = activeSlides($embla, embla);
      const prevBtn = $embla.querySelector(".embla__button--prev");
      const nextBtn = $embla.querySelector(".embla__button--next");
      let disablePrevAndNextBtns;
      if (prevBtn && nextBtn) {
        disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);
        setupPrevNextBtns(prevBtn, nextBtn, embla);
      }
      embla.on("select", () => {
        if (setSelectedDot)
          setSelectedDot();
        if (disablePrevAndNextBtns)
          disablePrevAndNextBtns();
        setActive($embla, embla);
      });
      embla.on("init", () => {
        $embla.classList.remove("invisible");
        $embla.classList.add("visible");
        if (setSelectedDot)
          setSelectedDot();
        if (disablePrevAndNextBtns)
          disablePrevAndNextBtns();
      });
      embla.on("scroll", () => {
      });
      embla.on("resize", () => {
      });
    };
    function main() {
      document.querySelectorAll(".embla").forEach(initEmblaSlider);
      document.querySelectorAll(".embla-async-wrapper").forEach(($asyncWrapper) => {
        const url = $asyncWrapper.dataset.url;
        fetch(url).then((response) => response.text()).then((text) => {
          $asyncWrapper.innerHTML = text;
          initEmblaSlider($asyncWrapper.querySelector(".embla"));
        }).catch((e) => {
          console.error(e);
        });
      });
    }
    main();
    window.initEmblaSlider = window.initEmblaSlider ?? initEmblaSlider;
  })();
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /** @license React v16.14.0
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

})();
